import React, {useRef, useCallback} from 'react'
import Moment from 'react-moment';
import { useSelector } from 'react-redux';
import MessageBar from './MessageBar'
import MsgForm from './MsgForm'

const MsgBox = ({messages, uid,load,EndData,isEmptyMsg, setLoad, fetchMoreMsg, roomId, compLength}) => {

  const observer=useRef();
  const scrollHere=useRef();
  const user=useSelector((state)=>(state.user.value));
  const compareTime=(newTime,oldTime)=>{

    var newTimeToDate=new Date(newTime.seconds*1000)
    var oldTimeTodate=new Date(oldTime.seconds*1000)
    var hours = Math.floor(Math.abs(oldTimeTodate - newTimeToDate) / 360000);
    if(hours>1){
      return(
        <p className='text-xs italic text-center text-slate-500 dark:text-slate-400'><Moment date={oldTimeTodate} format={"h:mmA, DD,MMM'YY"}/></p>
      )
    }
  }



  const lastMsg=useCallback(node=>{
    if(load) return

    if(observer.current){
      observer.current.disconnect()
    }

    observer.current=new IntersectionObserver(entries=>{
      if(entries[0].isIntersecting){
        if(!isEmptyMsg && !EndData && messages.length>=10){
          setLoad(true)
          fetchMoreMsg()
        }
      }
    })

  if(node){
      observer.current.observe(node)
    }
  },[load, messages])

  return (
    <div className='messenger-conversation'>
    {load && !isEmptyMsg &&
      <div className='messenger-load-pill'>
     <svg className="w-4 h-4 text-slate-400 animate-spin dark:text-slate-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
     </svg>
      </div>
    }
    
    <div className='messenger-message-list no-scrollbar'>
        <div ref={scrollHere}></div>
        {messages.length>0 && messages.map((msg, i)=>(
          <div key={msg.id || `${msg.createdAt?.seconds || 'pending'}-${i}`} >
            {i+1==messages.length && i>2 &&
            <p className='text-xs italic text-center text-slate-500 dark:text-slate-400'><Moment date={msg.createdAt.toDate()} format={"h:mmA, DD,MMM'YY"}/></p>
            }
           

          {messages.length===i+1?
          <div ref={lastMsg}>
            <MessageBar msg={msg} uid={uid} user={user} nextUid={i+1!=messages.length? messages[i+1].uid : ''} prevType={i>1? messages[i-1].msgType : ''}/>
          </div>
          :
          <div>
            <MessageBar msg={msg} uid={uid} user={user} nextUid={i+1!=messages.length? messages[i+1].uid : ''} prevType={i>1? messages[i-1].msgType : ''}/>
          </div>
          }

          {i>1 && msg.msgType==0 && msg.createdAt && messages[i-1].createdAt &&
              <>
             {compareTime(msg.createdAt, messages[i-1].createdAt)}
              </>
          }
         
        </div>

          ))}
          {isEmptyMsg && !load?
          <div className='messenger-empty-state'>
            <p>No messages yet</p>
            <span>Start the organisation chat below.</span>
          </div>
          :
          null}
      
    </div>
    <MsgForm roomId={roomId} scrollHere={scrollHere}/>

</div>
  )
}

export default MsgBox
